<template>
  <div class="middle-bottom">
    <div class="table">
      <div class="thead">
        <div class="i-item rank">序号</div>
        <div class="i-item name">设备类型</div>
        <div class="i-item percent">使用频次</div>
        <div class="i-item kcal">设备数量</div>
      </div>
      <div class="tbody high">
        <transition-group name="list" tag="div">
          <div class="item" v-for="(item, i) in p_list" :key="item.name">
            <div class="i-item rank">{{ i + 1 + p_step * page_size }}</div>
            <div class="i-item name">
              <div class="avatar">
                <img :src="item.big_icon" />
              </div>
              {{ item.name }}
            </div>
            <div class="i-item percent">{{ item.num }}</div>
            <div class="i-item kcal">{{ item.count }}</div>
          </div>
        </transition-group>
      </div>
    </div>
  </div>
</template>

<script>
let mtimer = null
let ltimer = null

export default {
  props: {
    count: {
      default: 10,
    },
    list: {
      default() {
        return []
      },
    },
  },
  data() {
    return {
      page_size: 5,

      active: 1,

      p_step: 0,
      c_step: 0,

      p_list: [],
      pList: [],
      c_list: [],
      cList: [],
    }
  },
  mounted() {
    this.page_size = 9

    this.p_step = 0
    this.pList = this.list

    this.$set(this, 'p_list', this.list.slice(0, this.page_size))
    // ltimer = setInterval(() => {
      // this.p_list = []

      // setTimeout(() => {
      //   let p_step = this.p_step + 1

      //   // console.log(p_step, Math.floor(this.pList.length / this.page_size))

      //   if (p_step > Math.ceil(this.pList.length / this.page_size) - 1) {
      //     p_step = 0
      //   }

      //   this.p_list = this.pList.slice(this.page_size * p_step, this.page_size * p_step + this.page_size)

      //   this.p_step = p_step
      // }, 800)
    // }, this.page_size * 2000)
  },
  beforeDestroy() {
    clearInterval(mtimer)
  },
  methods: {
    on_change(i) {
      this.active = i
    },
  },
}
</script>

<style scoped>
.list-enter-active {
  transition: all 1s;
  transform-origin: top;
}

.list-leave-active {
  transition: all 0.4s;
  transform-origin: bottom;
}

.list-enter {
  opacity: 0;
  transform: rotateX(90deg);
}

.list-leave-to {
  opacity: 0;
  transform: rotateX(90deg);
}
</style>

<style lang="less" scoped>
.middle-bottom {
  padding: 0 20px;
  .mhead {
    margin-top: -60px;
    padding: 13px 24px 20px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    .item {
      font-size: 18px;
      color: #97b4ff;
      opacity: 0.33;
      &.active {
        opacity: 1;
      }
      & + .item {
        margin-left: 20px;
      }
    }
  }
  .table {
    margin: 20px 0px 0;
    .thead {
      display: flex;
      align-items: center;
      background: rgba(68, 96, 218, 0.2);
    }
    .tbody {
      height: 470px;
      overflow: auto;
      .item {
        width: 100%;
        display: flex;
        align-items: center;
        border-bottom: 1px solid rgba(68, 96, 218, 0.2);
        .i-item {
          font-size: 16px;
          font-weight: normal;
          padding: 6px 0;
          color: #82a9ef;
        }
      }
    }
    .i-item {
      font-size: 16px;
      font-weight: 500;
      color: #00fbff;
      padding: 6px 0;
      &.rank {
        text-align: center;
        width: 25%;
      }
      &.name {
        width: 35%;
        display: flex;
        align-items: center;
        overflow: hidden; /* 超出部分隐藏 */
        white-space: nowrap; /* 文本不换行 */
        text-overflow: ellipsis; /* 省略的文本用省略号表示 */
        .avatar {
          width: 38px;
          height: 38px;
          border-radius: 50%;
          overflow: hidden;
          margin-right: 4px;
          background: #005ed2;
          display: flex;
          align-items: center;
          justify-content: center;
          img {
            width: 22px;
            height: 22px;
          }
        }
      }
      &.percent {
        text-align: center;
        width: 20%;
      }
      &.kcal {
        text-align: center;
        width: 20%;
      }
    }
  }
}
</style>
